"use strict";

exports.__esModule = true;
exports.getContrastColor = void 0;

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getContrastColor = hex => {
  const color = (0, _color.default)(hex);
  return color.isLight() && "black" || "white";
};

exports.getContrastColor = getContrastColor;